(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aerisim-collection-listing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadSearchResults = async (section) => {
      const params = new URLSearchParams(window.location.search);
      const query = (params.get('q') || '').trim();
      const input = section.querySelector('[data-aerisim-plans-query]');
      if (input) input.value = query;
      if (!query) return;

      const status = section.querySelector('[data-aerisim-plans-status]');
      const defaultResults = section.querySelector('[data-aerisim-plans-default-results]');
      const searchResults = section.querySelector('[data-aerisim-plans-search-results]');
      const sort = section.querySelector('[data-aerisim-plans-sort]');
      defaultResults.hidden = true;
      if (sort) sort.hidden = true;
      status.hidden = false;
      status.textContent = 'Searching plans…';

      const url = new URL(section.dataset.searchUrl, window.location.origin);
      url.searchParams.set('view', 'aerisim-plans');
      url.searchParams.set('type', 'product');
      url.searchParams.set('q', query);
      const page = Number(params.get('page'));
      if (Number.isSafeInteger(page) && page > 1) url.searchParams.set('page', String(page));

      try {
        const response = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Search request failed');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = document.querySelector('[data-aerisim-search-response]');
        if (!results) throw new Error('Search response missing');
        searchResults.replaceChildren(...Array.from(results.children));
        searchResults.hidden = false;
        const count = Number(results.dataset.resultsCount) || 0;
        status.textContent = `${count} ${count === 1 ? 'plan' : 'plans'} found for “${query}”`;
      } catch (error) {
        status.textContent = 'Search is temporarily unavailable. Please try again.';
      }
    };

    const init = () => document.querySelectorAll('[data-aerisim-plans-search]').forEach(loadSearchResults);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aerisim-compatible-devices"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__aerisimDevicesBound) return;
    window.__aerisimDevicesBound = true;

    const normalize = (value) => String(value)
      .toLocaleLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f\s\-_./()]+/g, '');

    const renderSuggestions = (section) => {
      const search = section.querySelector('[data-device-search]');
      const suggestions = section.querySelector('[data-device-suggestions]');
      const query = normalize(search.value);
      if (!suggestions || !query) {
        if (suggestions) suggestions.hidden = true;
        search.setAttribute('aria-expanded', 'false');
        return;
      }

      const matches = [...section.querySelectorAll('[data-device]')]
        .filter((device) => normalize(device.textContent).includes(query))
        .slice(0, 6);

      suggestions.replaceChildren();
      if (matches.length) {
        matches.forEach((device) => {
          const option = document.createElement('button');
          option.type = 'button';
          option.setAttribute('role', 'option');
          option.dataset.deviceSuggestion = 'true';
          option.dataset.deviceModel = device.querySelector('h3')?.textContent.trim() || '';
          option.innerHTML = '<span></span><strong></strong><em></em>';
          option.querySelector('span').textContent = device.querySelector('p')?.textContent.trim() || '';
          option.querySelector('strong').textContent = option.dataset.deviceModel;
          option.querySelector('em').textContent = device.querySelector('strong')?.textContent.trim() || '';
          suggestions.append(option);
        });
      } else {
        const empty = document.createElement('p');
        empty.textContent = 'No exact match in the verified list. Needs confirmation.';
        suggestions.append(empty);
      }

      suggestions.hidden = false;
      search.setAttribute('aria-expanded', 'true');
    };

    const updateDevices = (directory) => {
      const search = directory.closest('[data-aerisim-devices]').querySelector('[data-device-search]');
      const query = normalize(search.value);
      const activeFilter = directory.querySelector('[data-device-filter][aria-pressed="true"]')?.dataset.deviceFilter || 'all';
      const activeCategory = directory.querySelector('[data-device-category-filter][aria-pressed="true"]')?.dataset.deviceCategoryFilter || 'all';
      let visible = 0;

      directory.querySelectorAll('[data-device]').forEach((device) => {
        const matchesBrand = activeFilter === 'all' || normalize(device.dataset.brand) === activeFilter;
        const matchesCategory = activeCategory === 'all' || device.dataset.category === activeCategory;
        const matchesQuery = !query || normalize(device.textContent).includes(query);
        const show = matchesBrand && matchesCategory && matchesQuery;
        device.hidden = !show;
        if (show) visible += 1;
      });

      const empty = directory.querySelector('[data-device-empty]');
      if (empty) empty.hidden = visible !== 0;
      const clear = directory.closest('[data-aerisim-devices]').querySelector('[data-device-clear]');
      if (clear) clear.hidden = !query;
    };

    const initializeDevices = (section) => {
      const directory = section.querySelector('[data-device-list]')?.closest('.aerisim-devices__results');
      const filters = directory?.querySelector('[data-device-filters]');
      const categoryFilters = directory?.querySelector('[data-device-category-filters]');
      if (!directory || !filters || !categoryFilters || filters.dataset.ready) return;
      filters.dataset.ready = 'true';

      const categoryLabels = { phones_tablets: 'Phones & tablets', laptops: 'Laptops', watches: 'Smart watches', routers: 'Wi-Fi routers' };
      const categories = [...new Set([...directory.querySelectorAll('[data-device]')].map((device) => device.dataset.category).filter(Boolean))];
      categories.forEach((category) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-pressed', 'false');
        button.dataset.deviceCategoryFilter = category;
        button.textContent = categoryLabels[category] || category;
        categoryFilters.append(button);
      });

      const brands = [...new Set([...directory.querySelectorAll('[data-device]')].map((device) => device.dataset.brand).filter(Boolean))].sort((a, b) => a.localeCompare(b));
      brands.forEach((brand) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-pressed', 'false');
        button.dataset.deviceFilter = normalize(brand);
        button.textContent = brand;
        filters.append(button);
      });
    };

    document.querySelectorAll('[data-aerisim-devices]').forEach(initializeDevices);

    document.addEventListener('input', (event) => {
      const search = event.target.closest('[data-device-search]');
      if (!search) return;
      const section = search.closest('[data-aerisim-devices]');
      const directory = section.querySelector('.aerisim-devices__results');
      updateDevices(directory);
      renderSuggestions(section);
    });

    document.addEventListener('click', (event) => {
      const categoryFilter = event.target.closest('[data-device-category-filter]');
      if (categoryFilter) {
        const directory = categoryFilter.closest('.aerisim-devices__results');
        directory.querySelectorAll('[data-device-category-filter]').forEach((button) => button.setAttribute('aria-pressed', String(button === categoryFilter)));
        updateDevices(directory);
        return;
      }

      const filter = event.target.closest('[data-device-filter]');
      if (filter) {
        const directory = filter.closest('.aerisim-devices__results');
        directory.querySelectorAll('[data-device-filter]').forEach((button) => button.setAttribute('aria-pressed', String(button === filter)));
        updateDevices(directory);
        return;
      }

      const clear = event.target.closest('[data-device-clear]');
      if (clear) {
        const section = clear.closest('[data-aerisim-devices]');
        const search = section.querySelector('[data-device-search]');
        search.value = '';
        updateDevices(section.querySelector('.aerisim-devices__results'));
        renderSuggestions(section);
        search.focus();
        return;
      }

      const suggestion = event.target.closest('[data-device-suggestion]');
      if (suggestion) {
        const section = suggestion.closest('[data-aerisim-devices]');
        const search = section.querySelector('[data-device-search]');
        search.value = suggestion.dataset.deviceModel;
        updateDevices(section.querySelector('.aerisim-devices__results'));
        renderSuggestions(section);
        section.querySelector('.aerisim-devices__directory')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('.aerisim-devices__search')) return;
      document.querySelectorAll('[data-device-suggestions]').forEach((suggestions) => {
        suggestions.hidden = true;
        suggestions.closest('[data-aerisim-devices]')?.querySelector('[data-device-search]')?.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-aerisim-devices]').forEach(initializeDevices);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aerisim-destination-explorer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__aerisimDestinationExplorerBound) return;
    window.__aerisimDestinationExplorerBound = true;

    const activateChoice = (choice) => {
      const explorer = choice.closest('[data-aerisim-destination-explorer]');
      if (!explorer) return;
      const selectedId = choice.dataset.destinationId;
      explorer.querySelectorAll('[data-destination-choice]').forEach((item) => {
        item.setAttribute('aria-pressed', String(item.dataset.destinationId === selectedId));
      });
      explorer.querySelectorAll('[data-destination-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.destinationId !== selectedId;
      });
      const current = explorer.querySelector('[data-destination-current]');
      if (current) current.textContent = choice.dataset.destinationName;
      const dialog = explorer.querySelector('[data-destination-dialog]');
      if (dialog && dialog.open) dialog.close();
    };

    const filterChoices = (input) => {
      const group = input.closest('[data-destination-search-group]');
      if (!group) return;
      const query = input.value.trim().toLocaleLowerCase();
      let matches = 0;
      group.querySelectorAll('[data-destination-choice]').forEach((choice) => {
        const visible = choice.dataset.destinationName.toLocaleLowerCase().includes(query);
        choice.hidden = !visible;
        if (visible) matches += 1;
      });
      const noMatch = group.querySelector('[data-destination-no-match]');
      if (noMatch) noMatch.hidden = matches > 0;
    };

    document.addEventListener('click', (event) => {
      const choice = event.target.closest('[data-destination-choice]');
      if (choice) {
        activateChoice(choice);
        return;
      }
      const openButton = event.target.closest('[data-destination-open]');
      if (openButton) {
        const explorer = openButton.closest('[data-aerisim-destination-explorer]');
        const dialog = explorer && explorer.querySelector('[data-destination-dialog]');
        if (dialog && !dialog.open) {
          const search = dialog.querySelector('[data-destination-search]');
          if (search) {
            search.value = '';
            filterChoices(search);
          }
          dialog.showModal();
          if (search) search.focus();
        }
        return;
      }
      const closeButton = event.target.closest('[data-destination-close]');
      if (closeButton) {
        closeButton.closest('dialog').close();
        return;
      }
      if (event.target.matches('[data-destination-dialog]')) event.target.close();
    });

    document.addEventListener('input', (event) => {
      if (event.target.matches('[data-destination-search]')) filterChoices(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const choice = Array.from(document.querySelectorAll('.aerisim-destinations__sidebar [data-destination-choice]'))
        .find((item) => item.dataset.destinationId === event.detail.blockId);
      if (choice) activateChoice(choice);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aerisim-device-check-module"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__aerisimDeviceCheckModuleBound) return;
    window.__aerisimDeviceCheckModuleBound = true;
    window.__aerisimDeviceCatalogCache = window.__aerisimDeviceCatalogCache || new Map();

    const normalize = (value) => String(value || '')
      .toLocaleLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f\s\-_./()]+/g, '');

    const readCatalog = async (url) => {
      if (!window.__aerisimDeviceCatalogCache.has(url)) {
        const request = fetch(url, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error(`Device catalogue request failed: ${response.status}`);
            return response.text();
          })
          .then((html) => {
            const documentFromPage = new DOMParser().parseFromString(html, 'text/html');
            const devices = [...documentFromPage.querySelectorAll('[data-aerisim-devices] [data-device]')]
              .map((device) => {
                const brand = device.dataset.brand || device.querySelector('p')?.textContent.trim() || '';
                const model = device.querySelector('h3')?.textContent.trim() || '';
                const status = device.dataset.status || 'review';
                const statusLabel = [...device.children].find((child) => child.tagName === 'STRONG')?.textContent.trim() || '';
                return { brand, model, status, statusLabel };
              })
              .filter((device) => device.model);

            const uniqueDevices = new Map();
            devices.forEach((device) => {
              uniqueDevices.set(`${normalize(device.brand)}:${normalize(device.model)}`, device);
            });
            return [...uniqueDevices.values()];
          });
        window.__aerisimDeviceCatalogCache.set(url, request);
      }
      return window.__aerisimDeviceCatalogCache.get(url);
    };

    const getMatches = (devices, query) => {
      const normalizedQuery = normalize(query);
      if (!normalizedQuery) return [];

      return devices
        .map((device) => {
          const model = normalize(device.model);
          const brand = normalize(device.brand);
          const searchable = `${brand}${model}`;
          let score = 99;
          if (model === normalizedQuery) score = 0;
          else if (model.startsWith(normalizedQuery)) score = 1;
          else if (model.includes(normalizedQuery)) score = 2;
          else if (searchable.includes(normalizedQuery)) score = 3;
          return { device, score };
        })
        .filter((entry) => entry.score < 99)
        .sort((a, b) => a.score - b.score || a.device.model.localeCompare(b.device.model))
        .slice(0, 5)
        .map((entry) => entry.device);
    };

    const closeSuggestions = (module) => {
      const suggestions = module.querySelector('[data-device-check-suggestions]');
      const input = module.querySelector('[data-device-check-input]');
      suggestions.hidden = true;
      suggestions.replaceChildren();
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    };

    const renderState = (module, state, device = null) => {
      const result = module.querySelector('[data-device-check-result]');
      const brand = result.querySelector('[data-device-check-result-brand]');
      const title = result.querySelector('[data-device-check-result-title]');
      const text = result.querySelector('[data-device-check-result-text]');
      const link = result.querySelector('[data-device-check-result-link]');
      const stateKey = {
        not_supported: 'notSupported',
        not_found: 'notFound'
      }[state] || state;

      result.className = `aerisim-device-check-module__result is-${state.replace('_', '-')}`;
      brand.textContent = device ? `${device.brand} · ${device.model}` : '';
      title.textContent = module.dataset[`${stateKey}Title`] || '';
      text.textContent = module.dataset[`${stateKey}Text`] || '';
      link.hidden = state !== 'supported';
    };

    const renderSuggestions = (module, matches) => {
      const suggestions = module.querySelector('[data-device-check-suggestions]');
      const input = module.querySelector('[data-device-check-input]');
      suggestions.replaceChildren();

      matches.forEach((device, index) => {
        const option = document.createElement('button');
        option.type = 'button';
        option.id = `${input.id}-option-${index}`;
        option.setAttribute('role', 'option');
        option.dataset.deviceCheckOption = 'true';
        option.dataset.optionIndex = String(index);
        option.innerHTML = '<span></span><strong></strong><em></em>';
        option.querySelector('span').textContent = device.brand;
        option.querySelector('strong').textContent = device.model;
        option.querySelector('em').textContent = device.statusLabel || module.dataset.sourceLabel;
        option._device = device;
        suggestions.append(option);
      });

      suggestions.hidden = matches.length === 0;
      input.setAttribute('aria-expanded', String(matches.length > 0));
    };

    const selectDevice = (module, device) => {
      const input = module.querySelector('[data-device-check-input]');
      input.value = device.model;
      renderState(module, device.status, device);
      closeSuggestions(module);
    };

    const handleSearch = async (module) => {
      const input = module.querySelector('[data-device-check-input]');
      const clear = module.querySelector('[data-device-check-clear]');
      const query = input.value.trim();
      clear.hidden = !query;

      if (query.length < 2) {
        closeSuggestions(module);
        renderState(module, 'idle');
        return;
      }

      renderState(module, 'loading');
      try {
        const devices = await readCatalog(module.dataset.catalogUrl);
        if (input.value.trim() !== query) return;
        const matches = getMatches(devices, query);
        const exact = matches.find((device) => normalize(device.model) === normalize(query));

        if (exact) {
          selectDevice(module, exact);
          return;
        }

        renderSuggestions(module, matches);
        renderState(module, matches.length ? 'prompt' : 'not_found');
      } catch (error) {
        closeSuggestions(module);
        renderState(module, 'error');
      }
    };

    document.addEventListener('input', (event) => {
      const input = event.target.closest('[data-device-check-input]');
      if (!input) return;
      handleSearch(input.closest('[data-device-check-module]'));
    });

    document.addEventListener('keydown', (event) => {
      const input = event.target.closest('[data-device-check-input]');
      if (!input) return;
      const module = input.closest('[data-device-check-module]');
      const options = [...module.querySelectorAll('[data-device-check-option]')];
      if (!options.length) return;

      const current = options.findIndex((option) => option.getAttribute('aria-selected') === 'true');
      let next = current;
      if (event.key === 'ArrowDown') next = Math.min(current + 1, options.length - 1);
      else if (event.key === 'ArrowUp') next = Math.max(current - 1, 0);
      else if (event.key === 'Enter') {
        event.preventDefault();
        selectDevice(module, options[Math.max(current, 0)]._device);
        return;
      } else if (event.key === 'Escape') {
        closeSuggestions(module);
        return;
      } else {
        return;
      }

      event.preventDefault();
      options.forEach((option, index) => option.setAttribute('aria-selected', String(index === next)));
      input.setAttribute('aria-activedescendant', options[next].id);
      options[next].scrollIntoView({ block: 'nearest' });
    });

    document.addEventListener('click', (event) => {
      const option = event.target.closest('[data-device-check-option]');
      if (option) {
        selectDevice(option.closest('[data-device-check-module]'), option._device);
        return;
      }

      const clear = event.target.closest('[data-device-check-clear]');
      if (clear) {
        const module = clear.closest('[data-device-check-module]');
        const input = module.querySelector('[data-device-check-input]');
        input.value = '';
        clear.hidden = true;
        closeSuggestions(module);
        renderState(module, 'idle');
        input.focus();
        return;
      }

      document.querySelectorAll('[data-device-check-module]').forEach((module) => {
        if (!module.contains(event.target)) closeSuggestions(module);
      });
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-device-check-form]');
      if (!form) return;
      event.preventDefault();
      const first = form.closest('[data-device-check-module]').querySelector('[data-device-check-option]');
      if (first) selectDevice(form.closest('[data-device-check-module]'), first._device);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aerisim-esim-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (section.dataset.planSelectorReady === 'true') return;
      const form = section.querySelector('.aerisim-product__form');
      if (!form) return;
      section.dataset.planSelectorReady = 'true';

      const regionNames = typeof Intl.DisplayNames === 'function' ? new Intl.DisplayNames(['en'], { type: 'region' }) : null;
      const regionAliases = { UK: 'United Kingdom', US: 'United States', KR: 'South Korea', KP: 'North Korea', AE: 'United Arab Emirates', RU: 'Russia', TW: 'Taiwan', MO: 'Macau' };
      const regionName = (value) => {
        const code = String(value).trim().toUpperCase();
        if (!/^[A-Z]{2}$/.test(code)) return value;
        if (regionAliases[code]) return regionAliases[code];
        const name = regionNames?.of(code);
        return name && name !== code ? name : value;
      };
      const formatRegionCodes = (scope) => {
        scope.querySelectorAll('[data-region-codes]').forEach((element) => {
          let raw;
          try { raw = JSON.parse(element.dataset.regionCodes); } catch { return; }
          const values = Array.isArray(raw) ? raw : [raw];
          element.textContent = values.map((entry) => String(entry).split(/[,;/]+/).map((part) => {
            const trimmed = part.trim();
            const ipSuffix = trimmed.match(/^([a-z]{2})\s+IP$/i);
            return ipSuffix ? `${regionName(ipSuffix[1])} IP` : regionName(trimmed);
          }).join(', ')).join(', ');
        });
      };
      formatRegionCodes(section);

      const button = form.querySelector('.aerisim-product__add');
      const addPrice = form.querySelector('[data-add-price]');
      const addLabel = form.querySelector('[data-add-label]');
      const cartAnnouncement = form.querySelector('[data-cart-announcement]');
      let addLabelTimer;
      let purchasePending = false;
      const checkoutButton = form.querySelector('[data-direct-checkout]');
      const options = [...form.querySelectorAll('[data-plan-option]')];
      const variantDetailValues = [...section.querySelectorAll('[data-variant-detail-value]')];
      const variantDetailTemplates = new Map([...section.querySelectorAll('[data-variant-detail-template]')].map((template) => [`${template.dataset.variantId}:${template.dataset.blockId}`, template]));
      const renderVariantDetails = (variantId) => {
        variantDetailValues.forEach((target) => {
          const template = variantDetailTemplates.get(`${variantId}:${target.dataset.blockId}`);
          if (!template) return;
          target.replaceChildren(template.content.cloneNode(true));
          formatRegionCodes(target);
        });
      };
      const durationOptions = form.querySelector('[data-duration-options]');
      const durationHeading = form.querySelector('[data-duration-heading]');
      const durationTrigger = form.querySelector('[data-duration-trigger]');
      const dataTrigger = form.querySelector('[data-data-trigger]');
      const sheet = section.querySelector('[data-plan-sheet]');
      const sheetOptions = sheet?.querySelector('[data-sheet-options]');
      const selectedPlan = form.querySelector('[data-selected-plan]');
      const selectedNetwork = form.querySelector('[data-selected-network]');
      const selectedFup = form.querySelector('[data-selected-fup]');
      const summaryPrice = form.querySelector('[data-summary-price]');
      const durationLabel = (value) => value === 'other' ? 'Other plans' : `${value} ${Number(value) === 1 ? 'day' : 'days'}`;
      const bandRanks = { '5G': 5, '4G': 4, LTE: 4, '3G': 3, '2G': 2 };
      const parseNetworkEntries = (value) => {
        const entries = [];
        String(value || '').split('|').forEach((part) => {
          const match = part.trim().match(/^(?:([A-Z]{2})\s*:\s*)?(.+)$/i);
          if (!match) return;
          const code = (match[1] || '').toUpperCase();
          match[2].split(/,(?![^\[]*\])/).forEach((item) => {
            const operator = item.trim().match(/^(.+?)(?:\s*\[([^\]]+)\])?$/);
            if (!operator?.[1]?.trim()) return;
            const bands = [...new Set((operator[2] || '').split(/[;,/]+/).map((band) => band.trim().toUpperCase()).filter(Boolean))];
            entries.push({ code, name: operator[1].trim(), bands });
          });
        });
        return entries;
      };
      const parseNetwork = (value) => {
        const entries = parseNetworkEntries(value);
        if (!entries.length) return String(value || '').split(/[|,]/)[0].replace(/^[A-Z]{2}\s*:\s*/i, '').split('[')[0].trim() || 'Not specified';
        let selected = entries[0];
        let selectedBand = '';
        let selectedRank = -1;
        entries.forEach((entry) => entry.bands.forEach((band) => {
          if ((bandRanks[band] || 0) > selectedRank) {
            selected = entry;
            selectedBand = band === 'LTE' ? '4G' : band;
            selectedRank = bandRanks[band] || 0;
          }
        }));
        return [selected.name, selectedBand].filter(Boolean).join(' ');
      };

      const coverageDialog = section.querySelector('[data-coverage-dialog]');
      const coverageList = coverageDialog?.querySelector('[data-coverage-list]');
      const coverageSearch = coverageDialog?.querySelector('[data-coverage-search]');
      const coverageEmpty = coverageDialog?.querySelector('[data-coverage-empty]');
      const countryDetail = section.querySelector('[data-detail-key="country_code"] dd');
      const networkDetail = section.querySelector('[data-detail-key="network_list"] dd, [data-detail-key="network"] dd');
      const initialCountryContent = countryDetail?.innerHTML;
      const initialNetworkContent = networkDetail?.innerHTML;
      const productNetworkList = section.dataset.productNetworkList.trim();
      let coverageEntries = [];
      const parseRegionalCoverage = (value) => {
        const countries = new Map();
        parseNetworkEntries(value).forEach(({ code, name, bands }) => {
          if (!code) return;
          const country = countries.get(code) || { code, name: regionName(code), operators: [] };
          if (!country.operators.some((operator) => operator.name === name && operator.bands.join() === bands.join())) {
            country.operators.push({ name, bands });
          }
          countries.set(code, country);
        });
        return [...countries.values()].sort((a, b) => a.name.localeCompare(b.name));
      };
      const makeCoverageRow = (country, showCountry = true) => {
        const row = document.createElement('section');
        row.className = 'aerisim-product__coverage-country';
        const operators = document.createElement('ul');
        operators.className = 'aerisim-product__coverage-operators';
        country.operators.forEach((operator) => {
          const item = document.createElement('li');
          const operatorName = document.createElement('span');
          operatorName.textContent = operator.name;
          const bands = document.createElement('small');
          bands.textContent = operator.bands.join(' · ');
          item.append(operatorName, bands);
          operators.append(item);
        });
        if (showCountry) {
          const heading = document.createElement('h3');
          heading.textContent = country.name;
          row.append(heading);
        }
        row.append(operators);
        return row;
      };
      const renderCoverage = () => {
        if (!coverageList) return;
        const query = coverageSearch.value.trim().toLowerCase();
        const visible = coverageEntries.filter((country) => [country.name, country.code, ...country.operators.map((operator) => operator.name)].some((text) => text.toLowerCase().includes(query)));
        coverageList.replaceChildren(...visible.map(makeCoverageRow));
        coverageEmpty.hidden = visible.length > 0;
      };
      const updateCoverage = (variantNetwork) => {
        coverageEntries = parseRegionalCoverage(productNetworkList || variantNetwork);
        const available = coverageEntries.length > 0;
        section.querySelectorAll('[data-coverage-open]').forEach((trigger) => { trigger.hidden = !available; });
        if (!available) {
          if (countryDetail && initialCountryContent != null) countryDetail.innerHTML = initialCountryContent;
          if (networkDetail?.querySelector('[data-coverage-open], .aerisim-product__network-list-inline') && initialNetworkContent != null) networkDetail.innerHTML = initialNetworkContent;
          return;
        }
        const count = `${coverageEntries.length} ${coverageEntries.length === 1 ? 'country' : 'countries'}`;
        if (coverageDialog && countryDetail) countryDetail.textContent = count;
        if (networkDetail) {
          if (coverageDialog) {
            const trigger = document.createElement('button');
            trigger.type = 'button';
            trigger.className = 'aerisim-product__coverage-link aerisim-product__coverage-link--detail';
            trigger.dataset.coverageOpen = '';
            trigger.textContent = `View ${count} & networks`;
            networkDetail.replaceChildren(trigger);
          } else {
            const list = document.createElement('div');
            list.className = 'aerisim-product__network-list-inline';
            list.replaceChildren(...coverageEntries.map((country) => makeCoverageRow(country, false)));
            networkDetail.replaceChildren(list);
          }
        }
        if (!coverageDialog) return;
        coverageDialog.querySelector('[data-coverage-intro]').textContent = `${count} · Available networks for this product`;
        coverageSearch.value = '';
        renderCoverage();
      };
      coverageSearch?.addEventListener('input', renderCoverage);
      coverageDialog?.querySelector('[data-coverage-close]').addEventListener('click', () => coverageDialog.close());
      coverageDialog?.addEventListener('click', (event) => { if (event.target === coverageDialog) coverageDialog.close(); });
      section.addEventListener('click', (event) => {
        if (event.target.closest('[data-coverage-open]') && coverageEntries.length) coverageDialog?.showModal();
      });

      const durations = new Map();
      options.forEach((option) => {
        const input = option.querySelector('[data-variant-input]');
        const title = option.dataset.planTitle;
        const titleDuration = title.match(/\b(\d+)\s*(?:days?|d)\b/i);
        const validityDuration = input.dataset.validity.match(/\b(\d+)\s*(?:days?|d)?\b/i);
        const duration = titleDuration?.[1] || validityDuration?.[1];
        option.dataset.duration = duration ? String(Number(duration)) : 'other';
        const dataTitle = titleDuration ? title.replace(titleDuration[0], '') : title;
        const cleaned = dataTitle.replace(/^[\s/|·–—-]+|[\s/|·–—-]+$/g, '').trim() || title;
        const normalized = cleaned.replace(/\b(\d+(?:\.\d+)?)\s*(TB|GB|MB|Mbps|Kbps)\b/gi, '$1 $2');
        const kind = /^total\b/i.test(normalized) ? 'Total data' : /^daily\b/i.test(normalized) ? 'Daily data' : '';
        const dataLabel = normalized.replace(/^(?:total|daily)\s+/i, '').trim() || normalized;
        option.dataset.dataLabel = dataLabel;
        option.dataset.dataKind = kind;
        option.dataset.dataKey = normalized.toLowerCase().replace(/\s+/g, '');
        option.querySelector('[data-plan-data]').textContent = dataLabel;
        const kindElement = option.querySelector('[data-plan-kind]');
        kindElement.textContent = kind;
        kindElement.hidden = !kind;
        const group = durations.get(option.dataset.duration) || [];
        group.push(option);
        durations.set(option.dataset.duration, group);
      });
      const orderedDurations = [...durations.keys()].sort((a, b) => a === 'other' ? 1 : b === 'other' ? -1 : Number(a) - Number(b));
      let activeDuration = options.find((option) => option.querySelector('input:checked'))?.dataset.duration || orderedDurations[0];
      const selectedOption = () => options.find((option) => option.querySelector('input:checked'));
      const countAvailable = (duration) => (durations.get(duration) || []).filter((option) => !option.querySelector('input').disabled).length;

      const makeDurationButton = (duration, forSheet = false) => {
        const choice = document.createElement('button');
        choice.type = 'button';
        choice.className = forSheet ? 'aerisim-product__sheet-choice' : 'aerisim-product__duration-choice';
        choice.dataset.durationChoice = duration;
        choice.setAttribute('aria-pressed', String(duration === activeDuration));
        choice.disabled = countAvailable(duration) === 0;
        const title = document.createElement('strong');
        title.textContent = durationLabel(duration);
        const count = document.createElement('small');
        const available = countAvailable(duration);
        count.textContent = `${available} ${available === 1 ? 'plan' : 'plans'}`;
        choice.append(title, count);
        if (forSheet && duration === activeDuration) {
          const check = document.createElement('span');
          check.className = 'aerisim-product__choice-check';
          check.textContent = '✓';
          check.setAttribute('aria-hidden', 'true');
          choice.append(check);
        }
        choice.addEventListener('click', () => {
          const currentKey = selectedOption()?.dataset.dataKey;
          const availableOptions = (durations.get(duration) || []).filter((option) => !option.querySelector('input').disabled);
          const next = availableOptions.find((option) => option.dataset.dataKey === currentKey) || availableOptions[0];
          if (!next) return;
          next.querySelector('input').checked = true;
          next.querySelector('input').dispatchEvent(new Event('change', { bubbles: true }));
          sheet?.close();
        });
        return choice;
      };

      const renderSelection = () => {
        clearTimeout(addLabelTimer);
        const option = selectedOption();
        if (!option) return;
        const input = option.querySelector('input');
        activeDuration = option.dataset.duration;
        options.forEach((item) => { item.hidden = item.dataset.duration !== activeDuration; });
        durationHeading.textContent = durationLabel(activeDuration);
        durationOptions.replaceChildren(...orderedDurations.map((duration) => makeDurationButton(duration)));
        const displayData = [option.dataset.dataLabel, option.dataset.dataKind].filter(Boolean).join(' · ');
        const displayPlan = activeDuration === 'other' ? option.dataset.planTitle : `${durationLabel(activeDuration)} · ${displayData}`;
        selectedPlan.textContent = displayPlan;
        selectedNetwork.textContent = parseNetwork(input.dataset.network);
        selectedFup.textContent = input.dataset.fup || 'Not specified';
        summaryPrice.textContent = input.dataset.price;
        addPrice.textContent = input.dataset.price;
        addPrice.hidden = false;
        button.disabled = purchasePending || input.disabled;
        addLabel.textContent = input.disabled ? button.dataset.soldOutLabel : button.dataset.availableLabel;
        cartAnnouncement.textContent = '';
        checkoutButton.disabled = purchasePending || input.disabled;
        durationTrigger.querySelector('[data-duration-trigger-value]').textContent = durationLabel(activeDuration);
        durationTrigger.querySelector('[data-duration-trigger-count]').textContent = `${countAvailable(activeDuration)} plans available`;
        dataTrigger.querySelector('[data-data-trigger-value]').textContent = displayData;
        dataTrigger.querySelector('[data-data-trigger-price]').textContent = `${input.dataset.price} for ${durationLabel(activeDuration)}`;
        renderVariantDetails(input.value);
        updateCoverage(input.dataset.network);
      };

      const openSheet = (kind) => {
        if (!sheet) return;
        const dataChoices = (durations.get(activeDuration) || []).map((option) => {
          const input = option.querySelector('input');
          const choice = document.createElement('button');
          choice.type = 'button';
          choice.className = 'aerisim-product__sheet-choice aerisim-product__sheet-choice--data';
          choice.disabled = input.disabled;
          choice.setAttribute('aria-pressed', String(input.checked));
          const title = document.createElement('strong');
          title.textContent = option.dataset.dataLabel;
          const kindLabel = document.createElement('span');
          kindLabel.className = 'aerisim-product__sheet-data-kind';
          kindLabel.textContent = option.dataset.dataKind;
          kindLabel.hidden = !option.dataset.dataKind;
          const price = document.createElement('small');
          price.textContent = input.disabled ? 'Sold out' : input.dataset.price;
          choice.append(title, kindLabel, price);
          if (input.checked) {
            const check = document.createElement('span');
            check.className = 'aerisim-product__choice-check';
            check.textContent = '✓';
            check.setAttribute('aria-hidden', 'true');
            choice.append(check);
          }
          choice.addEventListener('click', () => {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            sheet.close();
          });
          return choice;
        });
        sheet.querySelector('[data-sheet-title]').textContent = kind === 'duration' ? 'Choose duration' : 'Choose data';
        sheet.querySelector('[data-sheet-subtitle]').textContent = kind === 'duration' ? 'Select your trip length.' : `Available for ${durationLabel(activeDuration)}.`;
        sheetOptions.replaceChildren(...(kind === 'duration' ? orderedDurations.map((duration) => makeDurationButton(duration, true)) : dataChoices));
        sheet.showModal();
      };

      if (options.length) {
        form.addEventListener('change', (event) => {
          const input = event.target.closest('[data-variant-input]');
          if (input?.checked) renderSelection();
        });
        durationTrigger.addEventListener('click', () => openSheet('duration'));
        dataTrigger.addEventListener('click', () => openSheet('data'));
        sheet.querySelector('[data-sheet-close]').addEventListener('click', () => sheet.close());
        renderSelection();
        section.dataset.planSelectorReady = 'true';
      } else {
        const rawNetwork = selectedNetwork.textContent;
        selectedNetwork.textContent = parseNetwork(rawNetwork);
        updateCoverage(rawNetwork);
      }

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (button.disabled || purchasePending) return;

        const selectedInput = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
        if (!selectedInput || selectedInput.disabled) return;

        clearTimeout(addLabelTimer);
        purchasePending = true;
        button.disabled = true;
        checkoutButton.disabled = true;
        addLabel.textContent = 'Adding…';
        addPrice.hidden = true;
        cartAnnouncement.textContent = '';

        try {
          const response = await fetch(section.dataset.cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this plan to the cart.');

          addLabel.textContent = '✓ Added to cart';
          cartAnnouncement.textContent = 'Added to cart';
          addLabelTimer = setTimeout(() => {
            if (addLabel.textContent === '✓ Added to cart') {
              addLabel.textContent = button.dataset.availableLabel;
              addPrice.hidden = false;
            }
          }, 2500);

          try {
            const cartResponse = await fetch(section.dataset.cartUrl, { headers: { Accept: 'application/json' } });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              document.querySelectorAll('.aerisim-header__cart').forEach((link) => {
                const count = link.querySelector('span');
                if (count) count.textContent = String(cart.item_count);
                link.setAttribute('aria-label', `${link.getAttribute('aria-label').replace(/\s*\(\d+\)$/, '')} (${cart.item_count})`);
              });
            }
          } catch (cartError) {
            console.warn('Cart count could not be refreshed.', cartError);
          }
        } catch (error) {
          addLabel.textContent = 'Could not add · Try again';
          cartAnnouncement.textContent = error.message || 'Unable to add this plan. Please try again.';
          addLabelTimer = setTimeout(() => {
            if (addLabel.textContent === 'Could not add · Try again') {
              addLabel.textContent = button.dataset.availableLabel;
              addPrice.hidden = false;
            }
          }, 3500);
        } finally {
          purchasePending = false;
          const currentInput = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
          button.disabled = !currentInput || currentInput.disabled;
          checkoutButton.disabled = !currentInput || currentInput.disabled;
        }
      });

      checkoutButton?.addEventListener('click', async () => {
        if (purchasePending) return;
        const selectedInput = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
        if (!selectedInput || selectedInput.disabled) return;

        const previousLabel = checkoutButton.innerHTML;
        purchasePending = true;
        checkoutButton.disabled = true;
        button.disabled = true;
        checkoutButton.textContent = 'Preparing checkout…';

        try {
          const cartResponse = await fetch(section.dataset.cartUrl, { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error('Unable to check your cart. Please try again.');
          const cart = await cartResponse.json();
          const alreadyInCart = cart.items.some((item) => Number(item.variant_id) === Number(selectedInput.value));

          if (!alreadyInCart) {
            const response = await fetch(section.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(selectedInput.value), quantity: 1 }] })
            });
            if (!response.ok) throw new Error('Unable to add this plan to the cart.');
          }
          window.location.assign(section.dataset.checkoutUrl);
        } catch (error) {
          purchasePending = false;
          button.disabled = selectedInput.disabled;
          checkoutButton.disabled = selectedInput.disabled;
          checkoutButton.innerHTML = previousLabel;
          window.alert(error.message || 'Unable to start checkout. Please try again.');
        }
      });
    };

    document.querySelectorAll('[data-aerisim-product]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-aerisim-product]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aerisim-faq-module"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__aerisimFaqModuleBound) return;
    window.__aerisimFaqModuleBound = true;

    document.addEventListener('toggle', (event) => {
      const item = event.target;
      if (!item.matches?.('[data-aerisim-faq-module-item][open]')) return;

      const module = item.closest('[data-aerisim-faq-module]');
      if (!module || module.dataset.singleOpen !== 'true') return;

      module.querySelectorAll('[data-aerisim-faq-module-item][open]').forEach((other) => {
        if (other !== item) other.open = false;
      });
    }, true);

    document.addEventListener('shopify:block:select', (event) => {
      const item = event.target.closest?.('[data-aerisim-faq-module-item]');
      if (item) item.open = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aerisim-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__aerisimFaqBound) return;
    window.__aerisimFaqBound = true;

    const normalize = (value) => value.toLocaleLowerCase().trim();

    const updateFaq = (faq) => {
      const search = faq.querySelector('[data-faq-search]');
      const activeCategory = faq.querySelector('[data-faq-category][aria-pressed="true"]')?.dataset.faqCategory || 'all';
      const query = normalize(search?.value || '');
      let visibleCount = 0;

      faq.querySelectorAll('[data-faq-item]').forEach((item) => {
        const matchesCategory = activeCategory === 'all' || item.dataset.category === activeCategory;
        const matchesQuery = !query || normalize(item.textContent).includes(query);
        const visible = matchesCategory && matchesQuery;
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      const count = faq.querySelector('[data-faq-count]');
      if (count) count.textContent = `${visibleCount} ${count.dataset.countLabel}`;
      const empty = faq.querySelector('[data-faq-empty]');
      if (empty) empty.hidden = visibleCount !== 0;
      const clear = faq.querySelector('[data-faq-clear]');
      if (clear) clear.hidden = !query;
    };

    document.addEventListener('input', (event) => {
      const search = event.target.closest('[data-faq-search]');
      if (!search) return;
      const faq = search.closest('[data-aerisim-faq]');
      if (faq) updateFaq(faq);
    });

    document.addEventListener('click', (event) => {
      const jump = event.target.closest('[data-faq-jump]');
      if (jump) {
        const faq = jump.closest('[data-aerisim-faq]');
        const search = faq.querySelector('[data-faq-search]');
        if (search) search.value = '';
        faq.querySelectorAll('[data-faq-category]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.faqCategory === jump.dataset.faqJump));
        });
        updateFaq(faq);
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        faq.querySelector('.aerisim-faq__content')?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        return;
      }

      const category = event.target.closest('[data-faq-category]');
      if (category) {
        const faq = category.closest('[data-aerisim-faq]');
        faq.querySelectorAll('[data-faq-category]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button === category));
        });
        updateFaq(faq);
        return;
      }

      const clear = event.target.closest('[data-faq-clear], [data-faq-reset]');
      if (clear) {
        const faq = clear.closest('[data-aerisim-faq]');
        const search = faq.querySelector('[data-faq-search]');
        search.value = '';
        faq.querySelectorAll('[data-faq-category]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.faqCategory === 'all'));
        });
        updateFaq(faq);
        search.focus();
      }
    });

    document.addEventListener('toggle', (event) => {
      const item = event.target.closest?.('[data-faq-item]');
      if (!item?.open) return;
      const faq = item.closest('[data-aerisim-faq]');
      faq.querySelectorAll('[data-faq-item][open]').forEach((other) => {
        if (other !== item) other.removeAttribute('open');
      });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aerisim-header"]) return;
  try {
    
  (() => {
    if (window.__aerisimHeaderMenuBound) return;
    window.__aerisimHeaderMenuBound = true;

    document.addEventListener('pointerdown', (event) => {
      document.querySelectorAll('.aerisim-nav__dropdown[open], .aerisim-mobile-plans[open]').forEach((menu) => {
        if (!menu.contains(event.target)) menu.removeAttribute('open');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('.aerisim-nav__dropdown[open], .aerisim-mobile-plans[open]').forEach((menu) => {
        menu.removeAttribute('open');
        menu.querySelector('summary')?.focus();
      });
    });

    document.addEventListener('change', (event) => {
      if (!event.target.matches('.aerisim-header__currency-select')) return;
      event.target.form?.submit();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const card = event.target.closest('.blog-post-card[data-article-url]');

    if (!card || event.target.closest('a, button, input, select, textarea')) return;

    window.location.assign(card.dataset.articleUrl);
  });

  document.addEventListener('keydown', (event) => {
    const card = event.target.closest('.blog-post-card[data-article-url]');

    if (!card || (event.key !== 'Enter' && event.key !== ' ')) return;

    event.preventDefault();
    window.location.assign(card.dataset.articleUrl);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
